import { applyTenantId, request } from '../request';

export function login(email: string, tenantId?: string) {
  let requestToCall = applyTenantId(tenantId);
  return requestToCall.get('/v2/identity/login-otp', {
    params: {
      email,
    },
  });
}

